var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_16399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5365 8.85712C16.744 8.85746 17.9288 9.18514 18.9648 9.8053C20.0008 10.4255 20.8494 11.3149 21.4201 12.379C21.9908 13.443 22.2624 14.6419 22.2059 15.8481C22.1494 17.0542 21.767 18.2225 21.0994 19.2285L22.2151 22.2143L18.4594 21.5385C17.5561 21.979 16.5652 22.21 15.5603 22.2142C14.5554 22.2184 13.5625 21.9959 12.6556 21.563C11.7487 21.1302 10.9511 20.4983 10.3224 19.7144C9.69359 18.9306 9.24983 18.0149 9.02414 17.0357C8.79844 16.0564 8.79663 15.0389 9.01884 14.0589C9.24105 13.0789 9.68155 12.1616 10.3075 11.3755C10.9335 10.5894 11.7288 9.95464 12.6342 9.5186C13.5395 9.08256 14.5316 8.85645 15.5365 8.85712Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4947 4.94426C15.4365 3.59766 13.9847 2.61455 12.3415 2.13179C10.6982 1.64904 8.94538 1.69068 7.32693 2.25091C5.70848 2.81115 4.305 3.86209 3.31188 5.25742C2.31877 6.65275 1.78544 8.32302 1.78617 10.0357C1.7813 11.6637 2.26284 13.2561 3.16903 14.6085L1.78617 18.2857L5.1176 17.6885",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_16399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInactive);
export default __webpack_public_path__ + "static/media/chat_inactive.2c0dbdacf80d8fe317b63f0fa21218e5.svg";
export { ForwardRef as ReactComponent };